export default function Title({
	title,
	subtitle,
}: {
	title?: string;
	subtitle?: string;
}) {
	return (
		<div
			className={`flex flex-col gap-0 justify-center z-2 
						hero-title-font-size
						leading-tight font-bold`}
		>
			<h1 className={``}>{title}</h1>
			<h2 className="mb-0 pb-0 text-[65%]">{subtitle}</h2>
		</div>
	);
}
